import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SettingsService } from "./../settings.service";
import { PatientsService } from "../patients.service";
import { AppointmentsService } from "./../appointments.service";
import { TranslateService } from "@ngx-translate/core";
import { LoginService } from "../login.service";
import { AnalyticsService } from "../analytics.service";

@Component({
    selector: "app-appointments-setup-nav",
    templateUrl: "./appointments-setup-nav.component.html",
    styleUrls: ["./appointments-setup-nav.component.scss"],
    standalone: false
})
export class AppointmentsSetupNavComponent implements OnInit {
  param: string | undefined;
  ApptsByRoom: string | undefined;
  hmoAppointments = false;
  displayHMOPrice = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private PatientsService: PatientsService,
    public SettingsService: SettingsService,
    public appointmentService: AppointmentsService,
    private translate: TranslateService,
    public loginService: LoginService,
    private analytics: AnalyticsService
  ) {}

  ngOnInit(): void {
    this.analytics.handleEntry(this.route, this.router, (key: string) => {
      if (!this.param) this.param = key;
      this.initClinic();
    });
  }

  private initClinic() {
    const key = this.param;
    if (!key) return;

    this.SettingsService.getClinic(key).subscribe(async (data: any) => {
      if (data.error) return;

      this.ApptsByRoom = data.ApptsByRoom ? "true" : "false";
      if (data.isCardio) this.loginService.isCardio = true;
      if (data.isGastro) this.loginService.isGastro = true;
      if (data.isEyes) this.loginService.isEyes = true;
      if (!data.isCardio && !data.isEyes && !data.isGastro) this.loginService.isObgyn = true;

      if (data.hmoAppointments) this.loginService.hmoAppointments = data.hmoAppointments;
      if (data.displayHMOPrice) this.loginService.displayHMOPrice = data.displayHMOPrice;
    });
  }
}
